import React, { useState } from "react";
import useHover from "../hooks/useHover";

const OptionItem = ({ name, image, onClick, color, func }) => {
  const hover = useHover();
  return (
    <div
      {...hover.divProps}
      className="divRow"
      onClick={() => onClick(name)}
      style={{
        width: "25%",
        minWidth: "350px",
        border: `4px solid gray`,
        height: "35px",
        marginTop: "4px",
        borderRadius: ".5rem/.5rem",
        justifyContent: "space-between",
        backgroundColor: hover.hover ? color : null,
        cursor: "pointer",
      }}
    >
      <div
        style={{
          fontFamily: "Roboto-Bold",
          flex: 1,
          textAlign: "center",
          fontSize: "20px",
          color: color == "black" && hover.hover ? "white" : null,
        }}
      >
        {`create ${name}`}
      </div>
      <img className="icon25" src={image} style={{ marginRight: "2px" }} />
    </div>
  );
};

export default OptionItem;
